export const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms))

export const TIMEOUT_ERROR = new Error('Timeout')

export const timeout = (ms) =>
  new Promise((_, reject) => setTimeout(() => reject(TIMEOUT_ERROR), ms))
